import React from 'react';
import PurchaseOrderProgressPresenter from './PurchaseOrderProgressPresenter';

import { colorSet } from '@components/Provider';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { Box, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { CapaQuotationChatMessageRfq } from '@generated/graphql';
import useDocuments from '@hooks/useDocuments';

const useStyles = makeStyles(() => {
  return {
    root: {
      width: 230,
      borderRadius: 10,
      backgroundColor: colorSet.gray000
    },
    header: {
      borderRadius: '10px 10px 0px 0px',
      padding: '10px 16px',
      color: colorSet.gray000,
      backgroundColor: colorSet.primary500
    },
    contentWrapper: {
      padding: '0px 16px 16px 16px'
    },
    content: {
      paddingTop: 16,
      borderTop: `1px solid ${colorSet.gray200}`
    },
    wordBreak: {
      wordBreak: 'break-all',
      '& b': {
        wordBreak: 'break-all'
      }
    },
    cta: {
      padding: 16
    }
  };
});

interface Props {
  chatMessage?: CapaQuotationChatMessageRfq;
}

const RejectRfqPurchaseOrderBubble = ({ chatMessage }: Props) => {
  const classes = useStyles();
  const history = useHistory();

  const { onUpdateDocumentsCurrentId } = useDocuments();
  const onClick = () => {
    if (chatMessage?.rfq?.purchaseOrderId) {
      onUpdateDocumentsCurrentId({
        selectedPurchaseOrderId: chatMessage?.rfq?.purchaseOrderId
      });
    }
    history.push(history.location.pathname + '?menu=purchaseorder');
  };

  return (
    <Box className={classes.root}>
      <div className={classes.header}>
        <CustomizedTypography variant="body2" fontWeight="bold" color="inherit">
          견적서
        </CustomizedTypography>
      </div>
      <PurchaseOrderProgressPresenter activeStep={2} />
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <CustomizedTypography
            variant="body1"
            fontWeight="bold"
            gutterBottoms={10}
            color="error"
          >
            발주서 거부
          </CustomizedTypography>
          <CustomizedTypography variant="body2" className={classes.wordBreak}>
            파트너가 발주서를 거부했습니다.
            <br />
            <br />
            [거부사유]
            <br />
            {chatMessage?.rfq?.rejectedReason ?? ''}
          </CustomizedTypography>
        </div>
      </div>

      <div className={classes.cta}>
        <CustomizedButton
          variant="contained"
          color="default"
          fullWidth
          onClick={onClick}
        >
          발주서 보기
        </CustomizedButton>
      </div>
    </Box>
  );
};

export default RejectRfqPurchaseOrderBubble;
